import { render, staticRenderFns } from "./PersonaBuscador.vue?vue&type=template&id=48d45ea4&scoped=true&"
import script from "./PersonaBuscador.vue?vue&type=script&lang=js&"
export * from "./PersonaBuscador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d45ea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
